function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.742 17.473c.154.094.335-.076.245-.233a2.865 2.865 0 01-.368-1.412c0-1.087.601-1.957 1.487-2.535.784-.512.57-1.173.7-1.96.077-.467.368-.891.611-1.174a.176.176 0 01.307.088c.144.884 1.29 2.388 1.952 3.37.76 1.133.712 2.13.706 2.206v.01c-.001.51-.135.99-.368 1.403-.09.158.091.33.246.233a5.295 5.295 0 002.386-3.394c.233-1.115.102-2.267-.275-3.333a7.916 7.916 0 00-.903-1.782c-1.208-1.797-3.31-4.552-3.563-6.163a.354.354 0 00-.617-.174 4.478 4.478 0 00-.586.835 4.877 4.877 0 00-.436 1.173 5.196 5.196 0 00.054 2.356c.063.25.144.493.242.73.095.228.196.458.214.707.028.464-.393.866-.849.866-.408 0-.747-.246-.834-.709a.176.176 0 00-.262-.12 5.254 5.254 0 00-2.593 4.532 5.267 5.267 0 002.504 4.48z",
  fill: "#000"
});

function SvgIconGaz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgIconGaz;